import React from 'react';
import { Box, Link } from '@mui/material';
import floatingButton1 from '../flare/floating-button-1.png';
import floatingButton2 from '../flare/floating-button-2.png';
import floatingButton3 from '../flare/floating-button-3.png';

interface ButtonItem {
    name: string;
    link: string;
    icon?: React.ReactNode;
}

interface FloatingButtonsProps {
    items: ButtonItem[];
}

const FloatingButtons: React.FC<FloatingButtonsProps> = ({ items }) => {
    // Desktop version - right side, vertical
    const DesktopButtons = (
        <Box
            sx={{
                position: 'fixed',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: 0,
                overflow: 'visible',
                '@media (max-width: 749px)': {
                    display: 'none',
                },
            }}
        >
            {items.map((item, index) => {
                const isFirst = index === 0;
                const isLast = index === items.length - 1;

                // Determine which background image to use
                let backgroundImage;
                if (items.length === 2) {
                    backgroundImage = isFirst ? floatingButton1 : floatingButton3;
                } else {
                    if (isFirst) {
                        backgroundImage = floatingButton1;
                    } else if (isLast) {
                        backgroundImage = floatingButton3;
                    } else {
                        backgroundImage = floatingButton2;
                    }
                }

                return (
                    <Link
                        key={index}
                        href={item.link}
                        sx={{
                            position: 'relative',
                            width: '125px',
                            height: '125px',
                            backgroundImage: `url(${backgroundImage})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            color: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textDecoration: 'none',
                            fontSize: '15px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            cursor: 'pointer',
                            gap: 1,
                            '&:hover': {
                                filter: 'brightness(1.1)',
                            },
                        }}
                    >
                        {item.icon && <Box sx={{ fontSize: '32px', display: 'flex', alignItems: 'center' }}>{item.icon}</Box>}
                        {item.name}
                    </Link>
                );
            })}
        </Box>
    );

    // Mobile version - bottom, horizontal
    const MobileButtons = (
        <Box
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'row',
                '@media (min-width: 750px)': {
                    display: 'none',
                },
            }}
        >
            {items.map((item, index) => (
                <Link
                    key={index}
                    href={item.link}
                    sx={{
                        flex: 1,
                        height: '50px',
                        backgroundColor: '#392112',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        cursor: 'pointer',
                        gap: 1,
                        '&:hover': {
                            backgroundColor: '#1d1109',
                        },
                    }}
                >
                    {item.icon && <Box sx={{ fontSize: '24px', display: 'flex', alignItems: 'center' }}>{item.icon}</Box>}
                    {item.name}
                </Link>
            ))}
        </Box>
    );

    return (
        <>
            {DesktopButtons}
            {MobileButtons}
        </>
    );
};

export default FloatingButtons;